import { render } from "./ClassUploadsDetails.vue?vue&type=template&id=707d4a81"
import script from "./ClassUploadsDetails.vue?vue&type=script&lang=js"
export * from "./ClassUploadsDetails.vue?vue&type=script&lang=js"

import "./ClassUploadsDetails.vue?vue&type=style&index=0&id=707d4a81&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__